import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import AdverseAction from './AdverseAction';
import messages from '../../../locale/messages';

function action({ store, intl }) {
    const title = intl.formatMessage(messages.adverseActionTitle);

    const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    if (!isAdminAuthenticated) {
        return { redirect: '/login' };
    }

    return {
        title,
        component: (
            <AdminLayout>
                <AdverseAction />
            </AdminLayout>
        ),
    };
}

export default action;
